<template>
  <div>
    <Breadcrumb :style="{margin: '24px 0'}">
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>网站设置</BreadcrumbItem>
        <BreadcrumbItem>数据备份</BreadcrumbItem>
    </Breadcrumb>
    <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
      <div style="height:50px;">
          <Button type="primary" @click="backup()">添加备份</Button>
      </div>
      <div>
        <!-- <Table border :columns="columns7" :data="data6"></Table> -->
        <Table border ref="selection" :columns="columns7" :data="data6"></Table><br>
        <!-- <span style="align:center"><Page :total="50"></Page></span> -->
      </div>
    </Content>
    <!-- 弹出框代码start -->
    <Modal
        v-model="modal1"
        @on-ok="ok"
        @on-cancel="cancel">
        <p>{{baktitle}}</p>
    </Modal>
    <!-- 弹出框代码end -->
  </div>
</template>
<style scoped>
</style>
<script>
import bak from '@/assets/js/views/bak/bak';

export default {
  ...bak,
};
</script>

